import http from "../http-common";
/* eslint-disable */
class KategoriBerita {
  kategoriBeritaList(page, itemPerPage, keyword) {
    return http.get(
      "/kategori-berita/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  kategoriBeritaListAll() {
    return http.get("/kategori-berita/list/all", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data, foto) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.name);
    bodyFormData.append("nama_en", data.name_en);
    bodyFormData.append("link", data.link);
    if (foto) {
      bodyFormData.append("foto", foto);
    }
    return http.post("/kategori-berita", bodyFormData, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(id, data, foto) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("nama", data.name);
    bodyFormData.append("nama_en", data.name_en);
    bodyFormData.append("link", data.link);
    if (foto) {
      bodyFormData.append("foto", foto);
    }

    return http.put(`/kategori-berita/${id}`, bodyFormData, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/kategori-berita/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new KategoriBerita();
